import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  leaves: [],
  selectedLeave: null,
  updatingAction: false,
};

const leaveDetailsSlice = createSlice({
  name: "companyLeaveDetails",
  initialState,
  reducers: {
    // Get Leaves
    getLeavesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getLeavesSuccess: (state, action) => {
      state.loading = false;
      state.leaves = action.payload;
      state.error = null;
    },
    getLeavesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Leave Action
    updateLeaveActionStart: (state) => {
      state.updatingAction = true;
      state.error = null;
    },
    updateLeaveActionSuccess: (state) => {
      state.updatingAction = false;
      state.error = null;
    },
    updateLeaveActionFailure: (state, action) => {
      state.updatingAction = false;
      state.error = action.payload;
    },

    // Set Selected Leave
    setSelectedLeave: (state, action) => {
      state.selectedLeave = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getLeavesStart,
  getLeavesSuccess,
  getLeavesFailure,
  updateLeaveActionStart,
  updateLeaveActionSuccess,
  updateLeaveActionFailure,
  setSelectedLeave,
  clearError,
} = leaveDetailsSlice.actions;

export default leaveDetailsSlice.reducer;
